var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedoOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H9C6.66667 18 5 16.3333 5 14C5 11.6667 6.66667 10 9 10H20C20.5614 10 21 9.5614 21 9C21 8.4386 20.5614 8 20 8H9C5.68421 8 3 10.6842 3 14C3 17.3158 5.68421 20 9 20H16C16.5614 20 17 19.5614 17 19C17 18.4386 16.5614 18 16 18ZM15.2982 5.70175L19.2982 9.70175C19.4737 9.89474 19.7193 10 20 10C20.5614 10 21 9.5614 21 9C21 8.7193 20.8947 8.47368 20.7018 8.29824L16.7018 4.29825C16.5263 4.10526 16.2807 4 16 4C15.4386 4 15 4.4386 15 5C15 5.2807 15.1053 5.52632 15.2982 5.70175ZM19.2982 8.29824L15.2982 12.2982C15.1053 12.4737 15 12.7193 15 13C15 13.5614 15.4386 14 16 14C16.2807 14 16.5263 13.8947 16.7018 13.7018L20.7018 9.70175C20.8947 9.52632 21 9.2807 21 9C21 8.4386 20.5614 8 20 8C19.7193 8 19.4737 8.10526 19.2982 8.29824Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoOutlined);
export default __webpack_public_path__ + "static/media/redo_outlined.95f5b002.svg";
export { ForwardRef as ReactComponent };